import {CanceledError, type InternalAxiosRequestConfig} from "axios";
import {LANDING_EVENTS_PATH} from "api/endpointPaths.mjs";
import {getConsent} from "consent/consentStore";
import {landingContextForPurchase} from "./landingVisit";
import {rememberLandingErasure} from "./landingErasure";

/** Capture before Firebase's async token read; enforce again immediately before Axios sends. */
export function landingRequestConsent(config: InternalAxiosRequestConfig): () => void {
	let body: unknown = config.data;
	if (typeof body === "string") {
		try { body = JSON.parse(body); }
		catch { return () => {}; }
	}
	if (body === null || typeof body !== "object") return () => {};
	const observation = config.url === LANDING_EVENTS_PATH;
	const key = observation ? "attribution" : "landingAttribution";
	if (!(key in body)) return () => {};
	const data = body as Record<string, unknown>;
	const captured = landingContextForPurchase(data[key], getConsent().analytics);
	return () => {
		const context = landingContextForPurchase(captured, getConsent().analytics);
		if (context !== undefined && rememberLandingErasure(context)) return;
		if (observation) throw new CanceledError("Landing analytics consent withdrawn");
		// A purchase and its legal acknowledgement continue without analytics, including a 401 retry.
		const {[key]: _attribution, ...purchase} = data;
		config.data = purchase;
	};
}
